@if (isOpen) {
<div class="cam-backdrop" (click)="onBackdropClick($event)">
  <div class="cam-card" (click)="$event.stopPropagation()">

    <!-- ── Icon ─────────────────────────────────────────────── -->
    <div class="cam-icon-wrap" [ngClass]="'cam-icon-wrap--' + data.icon">
      @switch (data.icon) {
      @case ('lock') {
      <!-- Lock glyph -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      }
      @case ('unlock') {
      <!-- Unlock glyph -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 9.9-1" />
      </svg>
      }
      @case ('warning') {
      <!-- Warning/Alert glyph -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      }
      @case ('trash') {
      <!-- Trash glyph -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6M14 11v6" />
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      </svg>
      }
      @case ('block') {
      <!-- Warning/Alert glyph -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      }
      @case ('no-entry') {
      <!-- Prohibition / no-entry circle -->
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
      </svg>
      }
      }
    </div>

    <!-- ── Title ─────────────────────────────────────────────── -->
    <h2 class="cam-title" [innerHTML]="parsedTitle"></h2>

    <!-- ── Description ──────────────────────────────────────── -->
     @if(data.icon === 'block') {
      <div class="cam-block-description">
        <p class="cam-description" [innerHTML]="parsedDescription"></p>
      </div>
     } @else {
       <p class="cam-description" [innerHTML]="parsedDescription"></p>
     }

    <!-- ── Effects box ──────────────────────────────────────── -->
    @if (data.effects && data.effects.length > 0) {
    <div class="cam-effects">
      @for (effect of data.effects; track $index) {
      <div class="cam-effect-row">
        <span class="cam-effect-icon" [ngClass]="'cam-effect-icon--' + effect.type">
          @if (effect.type === 'negative') {
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          }
        </span>
        <span class="cam-effect-text" [innerHTML]="parsedEffects[$index]"></span>
      </div>
      }
    </div>
    }

    <!-- ── Confirmation input ────────────────────────────────── -->
    @if (data.confirmation) {
    <div class="cam-confirm-section">
      <p class="cam-confirm-label">
        Type <strong>{{ data.confirmation.label }}</strong> to confirm
      </p>
      <input type="text" class="cam-confirm-input"
        [placeholder]="data.confirmation.placeholder ?? data.confirmation.expectedValue" [(ngModel)]="confirmationValue"
        autocomplete="off" spellcheck="false" />
    </div>
    }

    <!-- ── Reason input ──────────────────────────────────────── -->
    @if (data.reasonInput) {
    <div class="cam-confirm-section">
      <p class="cam-confirm-label">
        {{ data.reasonInput.label }}
      </p>
      <textarea class="cam-confirm-input" rows="3"
        [placeholder]="data.reasonInput.placeholder ?? ''" [(ngModel)]="reasonValue"
        spellcheck="false"></textarea>
    </div>
    }

    <!-- ── Footer actions ────────────────────────────────────── -->
    <div class="cam-footer">
      <!-- Audit log note (left side) -->
      @if (data.auditLog) {
        <span class="cam-audit-log"><strong>Logged</strong> in audit trail</span>
      }

      <div class="cam-footer-actions">
        <!-- Cancel is always hardcoded and always enabled -->
        <button type="button" class="cam-btn cam-btn--neutral" (click)="onDismiss()">
          Cancel
        </button>

        <!-- Dynamic action buttons -->
        @if(data.icon !== 'block') {
          @for (action of data.actions; track action.action) {
          <button type="button" class="cam-btn" [ngClass]="'cam-btn--' + action.style" [disabled]="isButtonDisabled(action)"
            (click)="onActionClick(action)">
            {{ action.label }}
            @if (action.icon === 'arrow-right') {
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
            }
          </button>
          }
        }
      </div>
    </div>

  </div>
</div>
}